// adding some validations logic for works form
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export const FORM_NEWS_TYPES_VALIDATIONS = {
  dataForm: {
    newsType: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(55)
    }
  }
};



// WEBPACK FOOTER //
// ./src/validations/formNewsTypes.js